/**
 * Generic "disabled with a reason" for any list item.
 *
 * Contract: an option/row carrying `disabledReason` (a string) is disabled, and the
 * reason shows as its hover tooltip. ListItem renders it, so it works in any list
 * built on it (filter panels, the cascade field picker, drilldowns, ...).
 *
 * Reasons are shown to users; keep them generic enough to reuse. Add a key for a new rule.
 */
export const DISABLED_REASONS = {
  NOT_IN_CONFIGURATION: "Not available with the current configuration",
};

/**
 * Sets `disabledReason` on each item for which `getReason(item)` returns one, and
 * lists disabled items last (stable). Combine several rules in one `getReason`;
 * the first reason wins.
 *
 * `keepOrder` skips the reordering, for lists whose order is structural.
 */
export const withDisabledReasons = (items, getReason, { keepOrder = false } = {}) => {
  const marked = items.map((item) => {
    const reason = getReason(item);
    return reason ? { ...item, disabledReason: reason } : item;
  });
  return keepOrder
    ? marked
    : [...marked].sort((a, b) => !!a?.disabledReason - !!b?.disabledReason);
};
